<template>
  <div class="container-xxl">
    <div class="row align-items-center">
      <div class="border-0">
        <div class="card-header py-1 no-bg bg-transparent d-flex align-items-center px-0 justify-content-between flex-wrap">
          <div class="d-flex py-2 project-tab flex-wrap justify-content-between gap-2">
            <div class="d-flex">
              <div class="d-flex w-100 text-nowrap align-items-center gap-2">
                <label for="filterDateYear" class="form-label mb-0">Επιλέξτε Έτος:</label>
                <select
                  v-model="filterYear"
                  id="filterDateYear"
                  class="form-select"
                  aria-label="Επιλέξτε έτος:"
                   @change="doSearch"
                >
                  <option v-for="year in years" :value="year.value">{{ year.value }}</option>
                </select>

                 <!-- Επιλογή Μήνα -->
<!--   <label for="filterMonth" class="form-label mb-0 ms-2">Μήνας:</label>
  <select
    v-model="filterMonth"
   
    id="filterMonth"
    class="form-select" style="min-width:150px"
    aria-label="Επιλέξτε μήνα"
  >
    <option value="">Όλοι</option>
    <option v-for="(monthName, index) in monthNames" :value="index + 1">{{ monthName }}</option>
  </select> -->
              </div>
            </div>

            </div>
                              <i class="wx-ic wx-ic-download" @click="exportData" title="Edit"></i>

          </div>
        </div>
     
      </div>
      <div class="row clearfix g-3">
        <div class="col-lg-12">
          <div>
            <div>
              <div class="card mb-2">
                <div class="card-body p-0 mt-3 table-responsive">
                  <table  class="table table-hover align-middle mb-0 mis_table" style="width:100%">
                    <thead>
                      <tr>
                        <th style="width:10%;" v-if="superUser || canViewAllDaysOff">
                      <div  class="d-flex align-items-center">
                        <select class="ms-1 nav-link rounded" name="" id="dropdownManagers"
                          @change="updateManagerFilter">
                          <option value="" selected>Όλοι οι εργαζόμενοι</option>
                          <option v-for="manager in managers" :key="manager.id"
                              :value="manager.id">
                              {{ manager.name }} {{ manager.surname }}
                          </option>
                        </select>
                        <img src="../assets/images/icons8-superman.svg" alt="Citrine Logo" class="menu-img ms-2" style="width:1.5em">

                      </div>
                      
                    </th>
                        <th  v-else>
                          Ονομ/μο</th>
                        <th style="width:6%;"><div>ΑΦΜ</div></th>
                        <th style="width:11%;"><div>ΣΥΝΟΛΟ ΚΑΝΟΝΙΚΗΣ</div></th>
                        <th style="width:10%;"><div>ΥΠΟΛΟΙΠΟ ΚΑΝΟΝΙΚΗΣ</div></th>

                        <th style="width:6%;" v-for="month in months" :key="month"><div>{{ month }}</div></th>
                      </tr>
                    </thead>
                      <tbody>

                    <template v-for="report in reports" :key="report.userId">
  <tr>
    <td>                                                <router-link :to="{ path: 'employee-profile', query: { id: report.userId } }">
{{ report.name }} {{ report.surname }}</router-link></td>
        <td>{{ report.afm }}</td>
<td>
  <div v-if="editingUserId !== report.userId" class="d-flex align-items-center justify-content-evenly" style="gap: 0.3em;">
    <span>{{ report.total_days_off_count }}</span>
    <button       v-if="filterYear === new Date().getFullYear()"
 class="btn btn-sm btn-link text-primary p-1" @click="startEditing(report)">
      <i class="wx-ic wx-ic-edit" title="Edit"></i>
    </button>
  </div>

  <div v-else class="d-flex align-items-center gap-2">
    <input type="number" v-model="editableDaysOff" min="0"
      class="form-control form-control-sm" style="width: 65px;" />
    <button class="btn btn-sm btn-success p-1" @click="submitTotalDaysOff(report.userId)">
      <i class="wx-ic wx-ic-check" title="Save"></i>
    </button>
    <button class="btn btn-sm btn-secondary p-1" @click="cancelEditing">
      <i class="wx-ic wx-ic-x" title="Cancel"></i>
    </button>
  </div>
</td>

    <td>{{ report.remaining_days_off_count }}</td>
    <td
      v-for="month in report.months"
      :key="month.month"
      @click="toggleMonthDetails(report.userId, month.month)"
      style="cursor: pointer;"
    >
      {{ month.count }}
    </td>
  </tr>
<tr v-if="expandedMonth && expandedMonth.userId === report.userId">
  <td></td> <!-- Username -->
  <td></td> <!-- Total -->
  <td></td> <!-- Remaining -->

  <td
    v-for="month in report.months"
    :key="'expanded-' + month.month"
  >
    <div v-if="month.month === expandedMonth.month">
      <div v-if="month.daysoff && month.daysoff.length">
        <strong>{{ month.month_name }}:</strong>
        <ul class="mb-0">
          <li v-for="off in month.daysoff" :key="off.id">
            Από: {{ formatDate(off.from) }} έως {{ formatDate(off.to) }} 

          </li>
        </ul>
      </div>
      <div v-else>Δεν υπάρχουν άδειες.</div>
    </div>
  </td>
</tr>


</template>

                      <tr class="col" v-if="!reports || !reports.length">
                          <td colspan="100">No data</td>


                        </tr>
                    </tbody>
</table> 
                </div>
              </div>
            </div>
          </div>
        </div>                         
      </div>
    </div>


    <div class="modal fade" id="dayOffModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title fw-bold" id="createprojectLabel">Days off details </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div v-if="selectedMonthData">
          <strong>{{ selectedMonthData.month_name }}:</strong>
          <ul v-if="selectedMonthData.daysoff && selectedMonthData.daysoff.length">
            <li v-for="off in selectedMonthData.daysoff" :key="off.id">
  <template v-if="off.from === off.to">
    {{ formatDate(off.from) }} <b>({{ (off.kind.title) }})</b>
  </template>
  <template v-else>
    <b>Από:</b> {{ formatDate(off.from) }} <b>έως</b> {{ formatDate(off.to) }} <b>({{ (off.kind.title) }})</b>
  </template>
</li>

          </ul>
          <div v-else>Δεν υπάρχουν άδειες.</div>
        </div>
            </div>
           
        </div>
    </div>
</div>
  </template>
  
  <script>
  import apiClient from '../services/api';
  import Select2 from 'vue3-select2-component';
    import { updateTotalDaysOff, exportDaysOff, fetchEmployees } from '@/services/employees';
  import { mapGetters } from 'vuex';
  import { ref, onMounted, computed } from 'vue';
import { useToast } from 'vue-toastification';

  export default {
    name: 'Days Off Reports',
    components: {
        Select2
    },
    computed: {
        ...mapGetters({
            getUserPermission: 'getUserPermission',
            getSuperUserPermission: 'getSuperUserPermission',

        }),
        superUser() {
            return this.getSuperUserPermission === 1;
        },
        userPermissions() {
            return this.getUserPermission('Days off reports');
        },
        canEditDayOff() {
            return this.userPermissions?.editCreator === 1;
        },
        canEditAllDaysOff() {
            return this.userPermissions?.editAll === 1;
        },
        canViewAllDaysOff() {
            return this.userPermissions?.viewAdmin === 1;
        },
        canCreateDayOff() {
            return this.userPermissions?.create === 1;
        },
        canArchive() {
            return this.userPermissions?.archive === 1;
        },
    },
    data() {
      return {
        filterYear: new Date().getFullYear(),
        filterMonth: '',
        select2Settings: {
              allowClear: true,
              placeholder: "Please select"
        },
        selectedUser: null,
        users: [],
        selectedManagerId: null,
        managers: [],
        reports: [],
        months: [],
        expandedMonth: null,
        selectedMonthData: null,
        editingUserId: null,
        editableDaysOff: null,

        years: [
          { value: (new Date().getFullYear() - 1), selected: '' },
          { value: new Date().getFullYear(), selected: 'selected="selected"' }
        ],
         monthNames: [
      'Ιανουάριος', 'Φεβρουάριος', 'Μάρτιος', 'Απρίλιος',
      'Μάιος', 'Ιούνιος', 'Ιούλιος', 'Αύγουστος',
      'Σεπτέμβριος', 'Οκτώβριος', 'Νοέμβριος', 'Δεκέμβριος'
    ],
      };
    },
    methods: {
      startEditing(report) {
    this.editingUserId = report.userId;
    this.editableDaysOff = report.total_days_off_count;
  },

  // Cancel editing
  cancelEditing() {
    this.editingUserId = null;
    this.editableDaysOff = null;
  },

 async exportData() {
      const toast = useToast();
      try {
        const formData = new FormData();
        formData.append('year', this.filterYear); // π.χ. 2025
        formData.append('month', this.filterMonth); 
        const response = await exportDaysOff(formData);

        if (response && response.status === 200) {
          // Χρησιμοποίησε *explicit* mime type
          const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          });

          // Πάρε filename από content-disposition αν υπάρχει
          let filename = `days_off_report_${this.filterYear}.xlsx`;
          const contentDisposition = response.headers['content-disposition'];
          if (contentDisposition && contentDisposition.indexOf('filename=') !== -1) {
            filename = contentDisposition
              .split('filename=')[1]
              .replace(/['"]/g, '')
              .trim();
          }

          // Φτιάξε προσωρινό download link
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);

          toast.success('Το αρχείο εξήχθη επιτυχώς!');
        } else {
          toast.error('Αποτυχία εξαγωγής αρχείου');
        }
      } catch (error) {
        console.error("Export error:", error);
        toast.error('Παρουσιάστηκε σφάλμα κατά την εξαγωγή');
      }
    },


  // Submit updated value
  async submitTotalDaysOff(userId) {
    if (this.editableDaysOff === null || isNaN(this.editableDaysOff)) {
      alert('Παρακαλώ εισάγετε έναν έγκυρο αριθμό');
      return;
    }

    const payload = new FormData();
    payload.append('total_days_off', this.editableDaysOff);

    const response = await updateTotalDaysOff(payload, userId);

    const toast = useToast();

    


    if (response.data && response.data.success) {
       toast.success(response.data.message);

      this.cancelEditing();
      this.fetchData(); // Refresh the table
    } else {
       toast.error(response.data.message);
    }
  },
      async fetchManagersData() {
      try {
        const response = await fetchEmployees();
        if (response.data.success) {
          this.managers = response.data.data;
        }
      } catch (error) {
        console.error('Failed to fetch managers:', error);
      }
    },
    getExpandedMonthDetails(report) {
  if (!report.months) return null;
  return report.months.find(m => m.month === this.expandedMonth.month);
},
   toggleMonthDetails(userId, monthNumber) {
  const userReport = this.reports.find(r => r.userId === userId);
  if (!userReport) return;

  const monthData = userReport.months.find(m => m.month === monthNumber);
    console.log('Daysoff data:', monthData?.daysoff);

  if (!monthData) return;

  this.selectedMonthData = monthData;

    console.log('selectedMonthData: ',  this.selectedMonthData);

  $("#dayOffModal").modal('toggle');

},

  formatDate(dateStr) {
  const date = new Date(dateStr);
  return date.toLocaleDateString('el-GR'); // π.χ. 02/01/2025
},

    
      fetchData(year, month, search, userId) {
        apiClient.get('get-days-off-report', {
          headers: {
            "Accept": "application/json",
            "Authorization": `Bearer ${localStorage.getItem('api_token')}`
          },
          params: {
            year: year || this.filterYear,
            userId: userId || this.selectedUser,
            search: search || $("#main-search-input").val()
          }
        })
        .then(response => {
          this.reports = response.data.data.data || [];
          this.months = response.data.data.months || [];
          let tmpEmployees = [];
          for (let i = 0; i < response.data.data.users.length; i++) {
              tmpEmployees.push({ id: response.data.data.users[i].id, text: response.data.data.users[i].name });
          }
          this.users = tmpEmployees;
        })
        .catch(error => {
          console.error(`status code: ${error.response.status}  jqXHR.responseText: ${error.response.data}`);
        });
      },
      doSearch() {
      this.fetchData(this.filterYear, this.filterMonth, $("#main-search-input").val(),  this.selectedManagerId);
    },
      updateManagerFilter(event) {
      this.selectedManagerId = event.target.value;
      this.doSearch();
    },
      applyServicesBindings() {
        $(document.body).on('click', '[data-selection-id]', function() {
          var selectionId = $(this).attr('data-selection-id');
          if ($(`[data-project-id-tasks="${selectionId}"]`).length > 1) {
            $(`[data-project-id-tasks="${selectionId}"]`).not('.reports_tasks_empty').each(function() {
              $(this).toggleClass('selectedRow');
              if ($(this).css('display') == 'none') {
                $(this).css('display', '');
              } else {
                $(this).css('display', 'none');
              }
            });
          } else {
            $(`[data-project-id-tasks="${selectionId}"]`).each(function() {
              $(this).toggleClass('selectedRow');
              if ($(this).css('display') == 'none') {
                $(this).css('display', '');
              } else {
                $(this).css('display', 'none');
              }
            });
          }
        });
  
        $(document.body).on('click', '.do-search', this.doSearch);
      }
    },
    async mounted() {
      this.applyServicesBindings();
      this.fetchData();
      this.fetchManagersData();

    }
  };
  </script>
  
  <style scoped>
  /* Add any component-specific styles here */
  </style>
  